export default __webpack_public_path__ + "static/media/№ KZ.M.07.2175 black.100f0185.svg";